const MOBILE = 900

export const isMobile = (): boolean =>
  window.matchMedia(`(max-width: ${MOBILE}px)`).matches

export const isDesktop = (): boolean => !isMobile()
